const initialState = {
  isMenuOpen: JSON.parse(localStorage.getItem("openMenu") || "true"),
};

const TOGGLE_MENU = "TOGGLE_MENU";

export const toggleMenu = () => ({
  type: TOGGLE_MENU,
});

const settingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_MENU:
      const newState = { isMenuOpen: !state.isMenuOpen };
      localStorage.setItem("openMenu", JSON.stringify(newState.isMenuOpen));
      return newState;
    default:
      return state;
  }
};

export default settingsReducer;
